import { render, staticRenderFns } from "./CurrentBillsList.vue?vue&type=template&id=6c5cd52f&scoped=true&"
import script from "./CurrentBillsList.vue?vue&type=script&lang=js&"
export * from "./CurrentBillsList.vue?vue&type=script&lang=js&"
import style0 from "./CurrentBillsList.vue?vue&type=style&index=0&id=6c5cd52f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5cd52f",
  null
  
)

export default component.exports